import React from "react";
import millify from "millify";
import { Link } from "react-router-dom";
import { useGetCryptosQuery } from "../services/cryptoApi";
import { Row, Col, Statistic, Typography } from "antd";

import {
  ArrowRightOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import Cryptocurrencies from "./Cryptocurrencies";
import News from "./News";
import Loader from "./Loader";
//import { Cryptocurrencies } from "../components";

const { Title } = Typography;
export default function Homepage() {
  const { data, isFetching } = useGetCryptosQuery();
  if (isFetching) return <Loader />;
  const globalData = data[0];
  return (
    <>
      <Title level={2} className="heading">
        Global Crypto Stats
      </Title>
      <Row>
        <Col span={12}>
          <Statistic
            title="Total Cryptocurrencies"
            value={millify(globalData.coins_count)}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Total Exchanges"
            value={millify(globalData.active_markets)}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Total Market Cap"
            value={millify(globalData.total_mcap)}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Total 24h Volume"
            value={millify(globalData.total_volume)}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Total Markets"
            value={millify(globalData.active_markets)}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Average marketcap change"
            value={globalData.mcap_change}
            precision={2}
            valueStyle={{ color: globalData.mcap_change < 0 ? "red" : "green" }}
            prefix={
              globalData.mcap_change < 0 ? (
                <ArrowDownOutlined />
              ) : (
                <ArrowUpOutlined />
              )
            }
            suffix="%"
          />
        </Col>
      </Row>
      <div className="home-heading-container">
        <Title level={2} className="home-title">
          Top 10 Cryptocurrencies in the world
        </Title>
        <Title level={5} className="show-more">
          <Link to="/cryptocurrencies">
            Show more
            <ArrowRightOutlined />
          </Link>
        </Title>
      </div>
      <Cryptocurrencies simplified />

      <div className="home-heading-container">
        <Title level={2} className="home-title">
          Latest Crypto News
        </Title>
        <Title level={5} className="show-more">
          <Link to="/news">
            Show more
            <ArrowRightOutlined />
          </Link>
        </Title>
      </div>
      <News simplified />
    </>
  );
}
